import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomImage from '@s-ui/react-atom-image'
import Context from '@s-ui/react-context'
import MoleculeModal, {moleculeModalSizes} from '@s-ui/react-molecule-modal'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'

import {useMessagingContext} from '../../useMessagingContext/index.js'

const HEADER_LOGO_HEIGHT = 20
const HEADER_LOGO_WIDTH = 130

const LOGO_ALT_TEXT = 'coches.net'

const HeaderLogo = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const urlStaticImages = config.get('URL_STATICS_IMAGES')

  const siteLogo = `${urlStaticImages}logo-coches.svg`

  return (
    <div className="mt-TransactionExternalInteractionModal-headerLogoWrapper">
      <AtomImage alt={LOGO_ALT_TEXT} src={siteLogo} height={HEADER_LOGO_HEIGHT} width={HEADER_LOGO_WIDTH} />
    </div>
  )
}

// eslint-disable-next-line react/prop-types
export const ExternalInteractionTransactionModal = ({showHeader = false}) => {
  const {state, setInteractionComponent} = useMessagingContext()
  const {interactionUrl} = state
  const {searchParams} = new URL(interactionUrl)
  const iframeUrl = searchParams.get('url')

  const isDesktopOrWider = useMediaQuery(useMediaQueryBreakpoints.lg)

  return (
    <MoleculeModal
      closeOnEscKeyDown
      closeOnOutsideClick
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      isOpen
      isPageScrollable={false}
      onClose={() => setInteractionComponent({component: null, show: false})}
      size={moleculeModalSizes.LARGE}
      {...(showHeader && {header: <HeaderLogo />})}
    >
      <iframe
        className="mt-TransactionExternalInteractionModal-iframe"
        frameBorder={0}
        height={isDesktopOrWider ? '600px' : '100%'}
        src={iframeUrl}
        width="100%"
      ></iframe>
    </MoleculeModal>
  )
}
